import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionHeroArchivePage from "components/SectionHeroArchivePage/SectionHeroArchivePage";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import { TaxonomyType } from "data/types";
import { FC, useEffect, useState } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import { Helmet } from "react-helmet-async";
import { getCategories } from "data/api";
// import { useScratch } from "react-use";

export interface ListingExperiencesPageProps {
  className?: string;
}

// let DEMO_CATS: TaxonomyType[] = [
//   {
//     id: "1",
//     href: "#",
//     name: "Enjoy the Beauty of Brazil ",
//     taxonomy: "category",
//     count: 17288,
//     thumbnail:
//       "https://images.pexels.com/photos/1118877/pexels-photo-1118877.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
//     listingType: "experiences",
//   },
//   {
//     id: "2",
//     href: "#",
//     name: "Enjoy the Beauty of Paris",
//     taxonomy: "category",
//     count: 2118,
//     thumbnail:
//       "https://images.pexels.com/photos/2412609/pexels-photo-2412609.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
//     listingType: "experiences",
//   },
//   {
//     id: "3",
//     href: "#",
//     name: "Enjoy the Beauty of Bangkok",
//     taxonomy: "category",
//     count: 36612,
//     thumbnail:
//       "https://images.pexels.com/photos/732895/pexels-photo-732895.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
//     listingType: "experiences",
//   },
//   {
//     id: "5",
//     href: "#",
//     name: "Enjoy the Beauty of Singapore",
//     taxonomy: "category",
//     count: 188288,
//     thumbnail:
//       "https://images.pexels.com/photos/3152124/pexels-photo-3152124.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
//     listingType: "experiences",
//   },
//   {
//     id: "4",
//     href: "#",
//     name: "Enjoy the Beauty of Seoul",
//     taxonomy: "category",
//     count: 188288,
//     thumbnail:
//       "https://images.pexels.com/photos/373290/pexels-photo-373290.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
//     listingType: "experiences",
//   },
// ];

const ListingExperiencesPage: FC<ListingExperiencesPageProps> = ({
  className = "",
}) => {
  const [demo_cats, setDemocats] = useState([]);
  useEffect(() => {
    getCategories().then((items) => {
      setDemocats(
        items.map((item: any) => ({
          id: item.id,
          name: item.title,
          thumbnail: item.image,
          taxonomy: "category",
          count: 2118,
          href: item.name,
        }))
      );
    });
  },[setDemocats]);

  return (
    <div
      className={`nc-ListingExperiencesPage relative overflow-hidden ${className}`}
      data-nc-id="ListingExperiencesPage"
    >
      <Helmet>
        <title>BCR LTD </title>
        <meta name="description" content="Explore BCR Ltd’s complete product range including Expansion Joint Covers, Luxury Metal Tile Trims, Shadow Gap Profiles, LED Profiles, Skirtings, Tactile Markers, and advanced building chemicals. Available across the UAE and GCC." />
      </Helmet>
      <BgGlassmorphism />

      <div className="container relative">
        {/* SECTION HERO */}
        <SectionHeroArchivePage
          currentPage="Experiences"
          currentTab="Experiences"
          listingType={
            <>
              <i className="text-2xl las la-umbrella-beach"></i>
              <span className="ml-2.5">1599 experiences</span>
            </>
          }
          className="pt-10 pb-24 lg:pb-28 lg:pt-16 "
        />

        {/* SECTION */}
        <SectionGridFilterCard className="pb-24 lg:pb-28" />

        {/* SECTION 1 */}
        <div className="relative py-16">
          <BackgroundSection />
          <SectionSliderNewCategories
            heading="Categories"
            subHeading="Explore our categories"
            categoryCardType="card4"
            itemPerRow={4}
            categories={demo_cats}
            sliderStyle="style2"
            uniqueClassName="ListingExperiencesPage"
          />
        </div>

        {/* SECTION */}
        <SectionSubscribe2 className="py-24 lg:py-28" />
      </div>
    </div>
  );
};

export default ListingExperiencesPage;
